import { render, staticRenderFns } from "./gameDataAnalysis.vue?vue&type=template&id=34edec2a&scoped=true"
import script from "./gameDataAnalysis.vue?vue&type=script&lang=js"
export * from "./gameDataAnalysis.vue?vue&type=script&lang=js"
import style0 from "./gameDataAnalysis.vue?vue&type=style&index=0&id=34edec2a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "34edec2a",
  null
  
)

export default component.exports